import { useParams } from 'react-router-dom';
import Container from '../UI/atoms/Container';

export default function Guide() {
  const { target } = useParams<{ target: string }>();

  let images: any[] = [];

  switch (target) {
    case 'smartStore1':
      images = ['smartStore1_1.png', 'smartStore1_2.png'];
      break;
    case 'smartStore2':
      images = ['smartStore2_1.png', 'smartStore2_2.png'];
      break;
    case 'wakeup_wemakeprice':
      images = ['wakeup_wemakeprice_1.png', 'wakeup_wemakeprice_2.png'];
      break;
    case 'wakeup_st11':
      images = ['wakeup_st11_1.png', 'wakeup_st11_2.png'];
      break;
    case 'wakeup_coupang':
      images = [
        'wakeup_coupang_title.png',
        'wakeup_coupang01.png',
        'wakeup_coupang02.png',
        'wakeup_coupang03.png',
        'wakeup_coupang04.png',
        'wakeup_coupang05.png',
        'wakeup_coupang06.png',
        'wakeup_coupang07.png',
      ];
      break;
    case 'scrap_prod_coupang':
      images = ['scrap_prod_1.png', 'scrap_prod_2.png', 'scrap_prod_3.png', 'scrap_prod_4.png', 'scrap_prod_5.png', 'scrap_prod_6.png'];
      break;
    case 'wakeup_alwayz':
      images = ['alwayz_main_1100.png'];
      break;
    case 'scrap_prod_alwayz':
      images = ['alwayz_scrap_prod_1.png', 'alwayz_scrap_prod_2.png', 'alwayz_scrap_prod_3.png', 'alwayz_scrap_prod_4.png', 'alwayz_scrap_prod_5.png'];
      break;
  }

  return (
    <Container noBody={true}>
      {images.map((one, index) => (
        <div key={index}>
          <img
            src={`${process.env.REACT_APP_FRONTEND_ENDPOINT}/images/help/${one}`}
            alt=""
            style={{
              width: '100%',
            }}
          />
        </div>
      ))}
    </Container>
  );
}
